module.exports = __webpack_public_path__ + "media/images/sp/stores/utsunomiya/utsunomiya_concept_01-a25fdaea4de397f2c28d8f17a380cb09.jpg";